/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'resources/less/themes/base/cookie_policy.less';

import storage from 'assets/js/common/storage/permanent';

$(function() {
    var cookiePolicy = {
        /**
         * @const {string}
         */
        STORAGE_KEY_COOKIE_POLICY: 'cookiePolicy',

        init: function() {
            if (this._isCookiePolicyAvailable()) {
                this._show();
            }
            this._getElement()
                .find('.cookie-policy-close')
                .on('click', this._close.bind(this));
        },

        /**
         * @private
         */
        _show: function() {
            this._getElement().removeClass('hidden');
        },

        /**
         * @private
         */
        _close: function() {
            this._getElement().addClass('hidden');
            storage.getInstance().setItem(this.STORAGE_KEY_COOKIE_POLICY, 'false');
        },

        /**
         * @returns {jQuery}
         * @private
         */
        _getElement: function() {
            return $('.cookie-policy');
        },

        /**
         * @returns {boolean}
         * @private
         */
        _isCookiePolicyAvailable: function() {
            return (
                storage.getInstance().getItem(this.STORAGE_KEY_COOKIE_POLICY) === null ||
                storage.getInstance().getItem(this.STORAGE_KEY_COOKIE_POLICY) !== 'false'
            );
        }
    };

    cookiePolicy.init();
});
